export const GET_ACTIVE_PROMO_EVENT = "GET_ACTIVE_PROMO_EVENT"
export const GET_ACTIVE_PROMO_EVENT_SUCCESS = "GET_ACTIVE_PROMO_EVENT_SUCCESS"

